// extracted by mini-css-extract-plugin
export default {"icon":"save-button_icon__SGXvd","placeHolderShimmer":"save-button_placeHolderShimmer__71iPf"};